/**
 * Terms of Service — placeholder route (production-ready shell for legal counsel review).
 * Public. No auth required.
 */
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { FileText } from "lucide-react";

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid-bg flex flex-col" data-testid="terms-page">
      <header className="px-6 sm:px-8 py-6 flex items-center justify-between">
        <Logo size="md" />
        <button onClick={() => navigate("/")} data-testid="terms-back-btn" className="text-slate-400 hover:text-white text-sm">← Back</button>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-6 sm:px-8 pb-24">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-300 text-xs font-semibold uppercase tracking-widest mb-6">
          <FileText size={12} /> Legal
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter text-white leading-tight">Terms of Service</h1>
        <p className="text-slate-400 mt-4 text-sm">Last updated · February 2026</p>

        <section className="mt-10 space-y-8 text-slate-300 text-[15px] leading-relaxed">
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">1. Service description</h2>
            <p>Receipt Sheets is a premium SaaS for receipt archival, OCR, tax reporting and team live-ops. Access requires an active Pro ($9.99/mo) or Business ($19.99/mo) subscription via Stripe.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">2. Acceptable use</h2>
            <p>You may not (a) upload content you don&apos;t own or have rights to, (b) attempt to reverse-engineer OCR pipelines, (c) resell the service without written permission, or (d) use the service for anything unlawful.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">3. Billing & refunds</h2>
            <p>Subscriptions renew automatically. Cancel any time via Billing → Stripe Portal. Pro-rated refunds honored within 30 days of purchase.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">4. Liability</h2>
            <p>Service is provided as-is. Total liability capped at 12 months of subscription fees paid.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">5. Contact</h2>
            <p className="font-mono text-sm text-emerald-300">legal@receiptsheets.com</p>
          </div>
          <p className="text-slate-500 text-xs italic border-t border-white/5 pt-6">
            This is a placeholder legal document. Full terms are under counsel review; production version replaces this shell prior to public sign-ups.
          </p>
        </section>
      </main>
    </div>
  );
}
